import { ReactNode } from 'react';
import { OverlayPlacement } from '@heroui/aria-utils';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@ds';

export type MenuItemType = {
  key: string;
  type: 'link' | 'action';
  to: string;
  label: ReactNode;
  onAction: (type: 'link' | 'action', to: string) => void;
};

type ActionMenuProps = {
  items: MenuItemType[];
  MenuTrigger: ReactNode;
  label: string;
  sizeClassName?: string;
  placement?: OverlayPlacement | undefined;
  disabledKeys?: string[];
  isDisabled?: boolean;
};

export const ActionMenu = ({
  items,
  MenuTrigger,
  label,
  placement,
  sizeClassName = 'w-[210px]',
  disabledKeys = [],
  isDisabled = false,
}: ActionMenuProps) => {
  const triggerNode = (
    <span className="inline-flex items-center justify-center" aria-label={label} role="button" tabIndex={0}>
      {MenuTrigger}
    </span>
  );

  return (
    <Dropdown
      isDisabled={isDisabled}
      placement={placement}
      classNames={{
        base: 'rounded-large bg-base-60',
        content: 'min-w-fit bg-base-60',
        trigger: 'cursor-pointer',
      }}
    >
      <DropdownTrigger>{triggerNode}</DropdownTrigger>

      <DropdownMenu
        aria-label={label}
        items={items}
        classNames={{
          base: sizeClassName,
          list: 'w-full',
        }}
        disabledKeys={disabledKeys}
      >
        {(item) => (
          <DropdownItem
            key={item.key}
            className="h-9 hover:bg-base-50"
            textValue={item.key}
            onClick={() => item.onAction(item.type, item.to)}
          >
            {item.label}
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
